import { render } from "./TicketLogs.vue?vue&type=template&id=bbd201f0"
import script from "./TicketLogs.vue?vue&type=script&lang=js"
export * from "./TicketLogs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__